export enum SupportedLanguages {
	BROWSER = 'BROWSER',
	FR = 'FR',
	EN = 'EN',
}

export interface IPreferencesModel {
	language: SupportedLanguages;
}
